export enum TraitementReeditionFacture_Statut {
    EnAttenteDeTraitement,
    EnCoursDeTraitement,
    Traite
}

export function TraitementReeditionFacture_Statut_ToText(input: TraitementReeditionFacture_Statut) {
    switch (input) {
        case TraitementReeditionFacture_Statut.EnAttenteDeTraitement:
            return 'Nouveau'
        case TraitementReeditionFacture_Statut.EnCoursDeTraitement:
            return 'En cours de traitement'
        case TraitementReeditionFacture_Statut.Traite:
            return 'Traité'
    }
}
